<template>
    <div class="header">
        <div class="grid-x grid-padding-x pad--small">
            <!-- Logo -->
            <div class="cell small-12 medium-1">
                <router-link
                    tag="span"
                    to="/"
                    class="link text-white">
                    <img
                        width="160"
                        src="../../../static/logos/logo.png"
                        alt="Customised Clothing" />
                </router-link>
                <span class="float-right show-for-small-only">
                    <i
                        v-if="navOpen === false"
                        v-on:click="toggleNav('open')"
                        class="material-icons text-white link">
                        menu
                    </i>
                    <i
                        v-if="navOpen === true"
                        v-on:click="toggleNav('close')"
                        class="material-icons text-white link">
                        close
                    </i>
                </span>
                <div class="show-for-small-only float-right">
                    <div class="basket-indicator">
                        <router-link
                            to="/checkout/basket"
                            tag="i"
                            class="material-icons text-white link s">
                            shopping_cart
                        </router-link>
                        <span class="basket-count">{{ basketCount }}</span>
                        <app-header-basket></app-header-basket>
                    </div>
                    <a
                        href="tel:441164670260"
                        tag="i"
                        class="material-icons text-white link s">
                        call
                    </a>
                    <a
                        href="mailto:sales@customisedclothing.com"
                        tag="i"
                        class="material-icons text-white link s">
                        mail_outline
                    </a>
                </div>
            </div>

            <div
                v-if="navOpen === true"
                class="show-for-small-only cell small-12">
                <ul class="mobile-nav">
                    <router-link
                        tag="li"
                        to="/order/design"
                        class="featured-link green">
                        Customise Now
                    </router-link>
                    <router-link
                        tag="li"
                        to="/garments/all"
                        class="featured-link">
                        <i class="material-icons white small">
                            add_circle
                        </i>
                        Shop Now
                    </router-link>
                    <router-link
                        tag="li"
                        to="/">Welcome
                    </router-link>
                    <router-link
                        tag="li"
                        to="/why-choose-us">
                        Why Choose Us
                    </router-link>
                    <a href="/blog/posts/"><li>Blog</li></a>
                    <router-link
                        tag="li"
                        to="/how-to-order">
                        How To Order
                    </router-link>
                    <router-link
                        tag="li"
                        to="/bulk-order">
                        Bulk Order
                    </router-link>
                    <li
                        v-if="isAuthenticated === true"
                        v-on:click="openLogin"
                        class="text-white small link">
                        <i class="material-icons text-white link">
                            person
                        </i>
                        Login / Register
                    </li>
                    <router-link
                        v-if="isAuthenticated === false"
                        tag="li"
                        to="/profile/my-profile"
                        class="text-white small link">
                        <i class="material-icons text-white link">
                            person
                        </i>
                        View profile
                    </router-link>
                    <router-link
                        v-if="isAuthenticated === false"
                        tag="li"
                        to="/profile/my-favourites"
                        class="text-white small link marg-left--small">
                        <i class="material-icons text-white link">
                            favorite
                        </i>
                    </router-link>
                    <li v-on:click="menuOpen = 1">Shop by brand</li>
                    <router-link
                        tag="li"
                        to="/garments/all">
                        Shop By Product
                    </router-link>
                    <router-link
                        tag="li"
                        to="/organic-sustainable">
                        Organic/Sustainable
                    </router-link>
                    <router-link
                        tag="li"
                        to="/customisation">
                        Customisation
                    </router-link>
                </ul>
            </div>

            <div class="cell small-12 medium-6 show-for-medium">
                <ul class="top-menu">
                    <router-link
                        tag="li"
                        to="/">Welcome
                    </router-link>
                    <router-link
                        tag="li"
                        to="/why-choose-us">
                        Why Choose Us
                    </router-link>
                    <a href="/blog/posts/"><li>Blog</li></a>
                    <router-link
                        tag="li"
                        to="/how-to-order">
                        How To Order
                    </router-link>
                    <router-link
                        tag="li"
                        to="/bulk-order">
                        Bulk Order
                    </router-link>
                </ul>
            </div>

            <div class="cell small-12 medium-3 pad-top--xs relative  show-for-medium">
                <div class="basket-indicator">
                    <router-link
                        to="/checkout/basket"
                        tag="i"
                        class="material-icons text-white link s">
                        shopping_cart
                    </router-link>
                    <span class="basket-count">{{ basketCount }}</span>
                    <app-header-basket></app-header-basket>
                </div>
                <a
                    href="tel:441164670260"
                    tag="i"
                    class="material-icons text-white link s">
                    call
                </a>
                <a href="tel:441164670260"><span style="color: #fff; font-size: 11px">0116 467 0260</span></a>
                <a
                    href="mailto:sales@customisedclothing.com"
                    tag="i"
                    class="material-icons text-white link s">
                    mail_outline
                </a>
                <a
                    href="mailto:sales@customisedclothing.com">
                    <span style="color: #fff; font-size: 11px">sales@customisedclothing.com</span>
                </a>
            </div>

            <div
                v-if="isAuthenticated === false"
                class="cell small-12 medium-2 show-for-medium">
                <span
                    v-on:click="openLogin"
                    class="text-white small link">
                    <i class="material-icons text-white link">
                        person
                    </i>
                    Login / Register
                </span>
            </div>

            <div
                v-else
                class="cell small-12 medium-2 show-for-medium">
                <router-link
                    to="/profile/my-profile"
                    class="text-white small link">
                    <i class="material-icons text-white link">
                        person
                    </i>
                    View profile
                </router-link>
                <router-link
                    to="/profile/my-favourites"
                    class="text-white small link marg-left--small">
                    <i class="material-icons text-white link">
                        favorite
                    </i>
                </router-link>
            </div>
        </div>

        <div
            class="grid-x grid-padding-x lower-nav-bar pad--small show-for-medium">
            <div class="cell small-12">
                <ul class="second-menu">
                    <li v-on:click="menuOpen = 1">Shop by brand</li>
                    <router-link
                        tag="li"
                        to="/garments/all">
                        Shop By Product
                    </router-link>
                    <router-link
                        tag="li"
                        to="/organic-sustainable">
                        Organic/Sustainable
                    </router-link>
                    <router-link
                        tag="li"
                        to="/workwear">
                        Workwear
                    </router-link>
                    <router-link
                        tag="li"
                        to="/customisation">
                        Customisation
                    </router-link>
                    <router-link
                        tag="li"
                        to="/order/design"
                        class="featured-link green">
                        Customise Now
                    </router-link>
                    <router-link
                        tag="li"
                        to="/garments/all"
                        class="featured-link">
                        <i class="material-icons white small">
                            add_circle
                        </i>
                        Shop Now
                    </router-link>
                </ul>
            </div>
        </div>
        <div
            v-if="menuOpen === 1"
            class="grid-x grid-padding-x shop-by-nav-bar pad--small bg--white">
            <div class="cell small-12">
                <ul class="brand-menu">
                    <router-link
                        tag="li"
                        class="image-link"
                        to="/garments/all?brand=American Apparel">
                        <img src="../../../static/logos/american-apparel.gif" alt="American Apparel" />
                    </router-link>
                    <router-link
                        tag="li"
                        class="image-link"
                        to="/garments/all?brand=Bella-Canvas">
                        <img src="../../../static/logos/bella.gif" alt="Bella Canvas" />
                    </router-link>
                    <router-link
                        tag="li"
                        class="image-link"
                        to="/garments/all?brand=Dickies">
                        <img src="../../../static/logos/dickies.gif" alt="Dickies" />
                    </router-link>
                    <router-link
                        tag="li"
                        class="image-link"
                        to="/garments/all?brand=Gildan">
                        <img src="../../../static/logos/gildan.gif" alt="Gildan" />
                    </router-link>
                    <router-link
                        tag="li"
                        class="image-link"
                        to="/garments/all?brand=Henbury">
                        <img src="../../../static/logos/henbury.gif" alt="Henbury" />
                    </router-link>
                    <router-link
                        tag="li"
                        class="image-link"
                        to="/garments/all?brand=Regatta">
                        <img src="../../../static/logos/regatta.gif" alt="Regatta" />
                    </router-link>
                    <router-link
                        tag="li"
                        class="image-link"
                        to="/garments/all?brand=Portwest">
                        <img src="../../../static/logos/portwest.gif" alt="Portwest" />
                    </router-link>
                    <router-link
                        tag="li"
                        class="image-link"
                        to="/garments/all?brand=Canterbury">
                        <img src="../../../static/logos/canterbury.gif" alt="Canterbury" />
                    </router-link>
                    <router-link
                        tag="li"
                        class="image-link"
                        to="/garments/all?brand=Russell">
                        <img src="../../../static/logos/russell.gif" alt="Russell" />
                    </router-link>
                </ul>
            </div>
        </div>
        <app-login v-if="loginOpen === true"></app-login>
    </div>
</template>

<script>
import Menu from '@/components/Header/Menu';
import Login from '@/components/Auth/Login';
import HeaderBasket from '@/components/Header/HeaderBasket';

export default {
    name: 'Header',
    components: {
        appMenu: Menu,
        appLogin: Login,
        appHeaderBasket: HeaderBasket,
    },
    data() {
        return {
            menuOpen: 0,
        };
    },
    computed: {
        loginOpen() {
            return this.$store.getters.loginOpen;
        },
        navOpen() {
            return this.$store.getters.navOpen;
        },
        basketCount() {
            return this.$store.getters.basketCount;
        },
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
        isHome() {
            let homePage = false;
            if (this.$route.path === '/') { homePage = true; }
            return homePage;
        },
    },
    methods: {
        toggleNav(direction) {
            this.$store.dispatch('toggleNav', { direction });
        },
        openLogin() {
            this.$store.dispatch('openLogin');
        },
    },
    watch: {
        $route() {
            this.menuOpen = 0;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Header/Header.vue